import LearnRKBHome from "../learnrkb/LearnRkbHome"
import DashBoardLayout from "../../components/layout/DashboardLayout"

export default function AdminLearnRKBPage() {
  return (
    <DashBoardLayout>
      <LearnRKBHome />
    </DashBoardLayout>
  );
}
